import ErrorBoundary from "components/Error/errorBoundary";
import React, {useState} from "react";
import {CONTACT} from "v4/data/entities";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import ListingEntityLayout from "v4/layouts/ListingEntityLayout/ListingEntityLayout";
import ListingHeaderEntityLayout from "v4/layouts/ListingHeaderEntityLayout/ListingHeaderEntityLayout";
import ContactsListingRowActions
    from "v4/pages/front/Contacts/components/ContactsListing/components/ContactsListingRowActions/ContactsListingRowActions";
import ContactsListingTools
    from "v4/pages/front/Contacts/components/ContactsListing/components/ContactsListingTools/ContactsListingTools";

import { useSearchContext } from "v4/contexts/SearchContext/SearchContext";

export default function ContactsListing() {
    const { tab } = useSearchContext();
    const {t} = usePolTranslation();
    const [totalItems, setTotalItems] = useState(null);

    return (
        <>
            <div className="page-list__content">
                <div className="table-container">
                    <ErrorBoundary>
                        <ListingHeaderEntityLayout totalItems={totalItems}
                                                   title={tab?.label ?? t('contacts')}
                                                   pageType='contacts'
                                                   resultsText={
                                                       t(`resultats_elements_contact${(totalItems > 1) ? 's' : ''}`, {count: totalItems})
                                                   }/>
                    </ErrorBoundary>
                    <ErrorBoundary>
                        <ListingEntityLayout entity={CONTACT}
                                             toolsRender={({checkedRows}) => <ContactsListingTools checkedRows={checkedRows}/>}
                                             rowActions={<ContactsListingRowActions />}
                                             tableClassName="contacts"
                                             setTotalItems={setTotalItems} />
                    </ErrorBoundary>
                </div>
            </div>
        </>
    )
}
